import React, { useState } from "react";

const faqItems = [
  {
    question: "1. Как заказать и получить посылку?",
    answer: `Шаг 1.  Вам нужно зарегистрироваться на сайте Onza.kg или скачать приложение Onza
          После регистрации Вы получите свой KG код, который обязательно нужно указать в адресной строке при заказе. Этот код позволяет идентифицировать Ваш заказ и при получении на наш зарубежный склад принять его на Ваш аккаунт/кабинет. 
          Шаг 2.  
          1)  Выбираете сайт, на котором нужно заказать, товар.
          2)  Выбранный товар на сайте нужно положить в корзину.
          3)  Переходите в корзину и нажимаете выкупить. 
          4)  Нужно указать Ваше имя и фамилию, Вашу электронную почту, туда будут приходить письма, информирующие о ходе доставки Вашего заказа.
          5)  При выкупе вводите адрес нашего зарубежного склада. Адрес можно найти в разделе «Адреса» нашего Приложения или Сайта. Там же будет Ваш KG код указан. Его нужно ввести обязательно. 
          Шаг 3.   
          Вводите данные Вашей карты и оплачиваете. CVV – это 3 цифры на оборотней стороне карты.
          Шаг 4.   
          На электронную почту Вы получите письмо от сайта, где была совершена покупка, о подтверждении заказа и номером заказа. 
          Далее, Вы получите следующие письма от сайта:
          - Мы отгрузили Ваш товар: в этом письме будет указано ожидаемая дата доставки и будет кнопка с активной ссылкой «Track my order», перейдя по этой ссылке Вы можете отслеживать маршрут Вашей посылки. Трек – это номер отслеживания, он состоит из множества цифр или букв с цифрами. Трек является уникальным. 
          
          - Мы доставили Ваш товар: в этом письме будет дата и время доставки.  
          Шаг 5.   
          Наш зарубежный склад, получив посылку, сканирует трек и Ваш KG код. Таким образом, посылка попадает на Ваш аккаунт/кабинет. Далее через наш сайт/приложение Вы сможете отследить дальнейший маршрут посылки. 
          До прилета посылки в Бишкек Вам нужно задекларировать заказ свой. Для этого, Вы нажимаете «Декларировать», выбираете валюту, указываете стоимость товара и загружаете инвойс. Декларация нужна для того, чтобы мы предоставили документы таможенным органам согласно законодательству.
          Инвойс – может быть:
          - просто скрин письма о подтверждении заказа, где видно товар и стоимость заказа. Этот скрин можно легко загрузить, нажав скрепку, или
          - Pdf чек, которые прислал магазин на почту.
          Посылка окажется в разделе «В пути» как только вылетит в Бишкек. 
          После таможенного досмотра и получения на склад в г. Бишкек посылка окажется в разделе «В Кыргызстане». Значит Вы можете оплатить за доставку и получить свою посылку.`,
  },
  {
    question: "2. Где найти сайты, чтобы заказать?",
    answer: `В разделе «Магазины» Сайта/Приложения Onza.kg Вы найдете ссылки на популярные магазины.
        Список магазинов не ограничен. Вы можете заказать с любого сайт, которые доставляет до наших складов в США или в Испании.`,
  },
  {
    question: "3. Должен ли я что то сделать после заказа и выкупа товара на сайте?",
    answer: `Вы на почту получите письмо от магазина или курьерской компании, где будут  указаны ожидаемая дата доставки и трек (или ссылка на трек). 
      Трек выглядит как набор цифр и/или букв, он будет выглядеть примерно так:
      %002900305258927124741327724
      HM032615411ES
      36416562142300100031
      1ZG223156800589794
      TBA111790989098
      1LS799890000
      и пр.
      В течение 1-2 рабочих дней трек от посылки должен появиться в кнопке «На зарубежном складе». Если трек от посылки не появился, Вам необходимо НЕЗАМЕДЛИТЕЛЬНО сообщить нам об отсутствии доставленной посылки. 
      
      Далее, мы проверяем:
      верность заполнения адреса при покупке, 
      верность заполнения кода клиента при покупке,
      скрок доставки по трекам, 
      подпись лица получившего посылку согласно данным курьерской компании,
      возможность возникновения в кабинете другого трека (в 30% случаев у посылки есть дополнительные треки, которые попадают в Ваш кабинет). 
      Если все верно и посылки все равно нет, то поднимаем записи камер, чтобы проверить была ли действительно доставка. Весь процесс проверку коммуницируется с Вами по whatsapp. 
      
      При сообщениях об отсутствии посылки в приложении/в кабинете на сайте через 2 недели после доставки часто невозможно уже найти посылку.  О том, когда будет доставлена Ваша посылка знаете только Вы, больше никто, так как письма приходят на Вашу электронную почту и только ВЫ знаете про свой заказ.  Следовательно, Вы должны контролировать поступление Вашей посылки и сообщать об ее отсутствии.`,
  },
  {
    question: "4. Буду ли я платить таможенные пошлины?",
    answer: `Каждый случай необходимо уточнять через наш WhatsApp. Перейти в чат можно прямо из приложения — нажмите на значок чата в правом верхнем углу рядом с кнопкой звонка.
  
      Согласно законодательству беспошлинный порог ввоза товаров для личного пользования на одно физическое лицо ограничен 200 евро или 31 кг. 
      
      При заказе для других физических лиц (Получатели) Вы можете добавить данные «Получателей» в кабинете в соответствующем разделе. После получения посылки на зарубежный склад появится кнопка «Декларировать», где можно выбрать соответствующего получателя из ранее добавленных получателей.`,
  },
  {
    question: "5. Какие сроки доставки посылок?",
    answer: `Этап 1. С момента заказа до получения на наш зарубежный склад: 
  
          Сроки доставки с момента оформления заказа на сайте до получения нашим складом полностью зависят от сайта, на котором был сделан заказ. У каждого сайта свои сроки доставки, которые можно прочитать в их разделе доставка или при оформлении заказа после ввода адреса нашего склада сайт покажет сроки доставки. 
          Этап 2. С получения заказа на наш зарубежный склад до выдачи в Бишкеке: 
          После отправки посылки с зарубежного склада примерно через неделю посылка будет на выдаче в г. Бишкек, за исключением форс-мажорных обстоятельств. 
          Из США груз отправляем по пятницам. 
          Из Испании 2 раза в неделю по понедельникам и четвергам.
  
          Декабрь и январь, как правило, крайне загруженные месяцы (из-за Черной пятницы, Рождества, праздничных дней) и не исключаются задержки от 3 до 7 дней в этот период. В этот период рекомендуется заказы совершать заранее.`,
  },
  {
    question: "6. Есть ли товары, которые нельзя заказывать?",
    answer: `Скоропортящиеся продукты питания
          Денежные знаки и их эквиваленты
          Оружие
          Токсичные и инфекционные вещества
          Табак, сигареты
          Военное оборудование
          Предметы искусства
          Растения, цветы
          Более 2 штук: парфюмерия, косметические спреи и эфирные масла (разрешено только 2 шт.)
          Взрывоопасные и легковоспламеняющиеся вещества
          Документы
          Литий-ионные батареи и аккумуляторы (разрешены только в устройствах с мощностью не выше 100 Вт)`,
  },
  {
    question: "7. Зачем мои паспортные данные при регистрации?",
    answer: `Согласно законодательству Кыргызской Республики, импорт товаров на территории страны подлежит обязательному декларированию. 
          Все таможенные формальности мы берем на себя. Вам достаточно при регистрации указать паспортные данные и адрес. 
          Мы полностью соблюдаем законодательство о защите персональных данных.`,
  },
  {
    question: "8. Как я узнаю о доставке и где я могу получать посылки?",
    answer: "Статус посылок Вы можете отслеживать на Сайте/в Приложении. Кроме того, Вы получите сообщение на WhatsApp и электронную почту. Адрес ПВЗ указаны в разделе Контакты. Обратите, пожалуйста, внимание на часы работы и обеденные перерывы. ",
  },
  {
    question: "9. Как рассчитывается стоимость доставки при наличии коробок? ",
    answer: `Для расчета стоимости доставки по посылке в коробке сравниваются:
      Физический вес и
      Объемный вес: длина × ширина × высота (в см) / 6000.
      Если объемный вес посылки превышает физический вес, то дополнительно к тарифу Клиент оплачивает 60 сом за каждый 100 грамм превышения объемного веса над физическим весом.
      Пример: Кроссовки 42 размера в коробке из США, физический вес 1 кг
      Параметры коробки: 35 см x 25 см x 13 см
      Объемный вес: (35*25*13)/6000=1,9 кг.
      Превышение объемного веса над физическим = 1,9 кг – 1 кг   = 0,9 кг
      Стоимость доставки =1*900 (тариф США) + 0,9*600 (тариф для превышения) = 1440 сом
      Вывод: если бы Клиент отказался от коробки, то заплатил бы за доставку только 900 сом, но с коробкой заплатил 1440 сом.`,
  },
  {
    question: "10.  Хочу заказать телефон/ноутбук/технику, какие пошлины будут? ",
    answer: `Таможенные пошлины составляю 15% от суммы заказа выше 200 евро. 
          Пример: Если телефон 1200 долл, то минусуем 200 евро в долларах, 1200-200*1.1=980 долл 980*15%=147 долл будут пошлины. 
          
          Дополнительно за таможенное декларирование мы выставляем 1500 сом (за брокерские услуги).
          
          Для получения imei для телефона необходима таможенная декларация, которую мы предоставляем. Порядок регистрации на сайтe можно найти на сайте https://imei.kg/faq 
          Для регистрации устройства для личного пользования включая доставку через международные почтовые и курьерские отправления, подлежат обязательной регистрации в ГСИ в срок не позднее 30 дней с момента первого подключения к сети операторов Кыргызской Республики.`,
  },
  {
    question: "11.  Некоторые американские сайты не принимают банковскую карту? ",
    answer: "Мы выкупаем в таких случаях. Вам нужно скинуть ссылку на товар в разделе «Купи вместо меня» или на наш WhatsApp. Тариф по выкупу с использованием нашей американской карты составляет 10% от суммы заказа.",
  },
  {
    question: "12. Что делать если брендовая коробка от сумок или обуви нужна?",
    answer: `Нажмите кнопку:
      - «Профиль» в правом верхнем углу приложения,
      - ⁠ нажмите «Правила переупаковки», 
      - ⁠ нажмите «Брендовая коробка нужна».  
      Если на последующие заказы коробки от обуви или сумок не нужны, то нужно нажать кнопку «Брендовая коробка не нужна» после получения заказа в коробке «На зарубежный склад».`,
  },
  {
    question: "13. Могу ли я сделать возврат товара или отмену заказа?",
    answer: `Вы можете вернуть товар/отменить заказ только ДО прибытия товара на зарубежный склад. После прибытия товара на зарубежный склад возврат невозможен, т.к. товар уже будет передан на запаковку в боксы. 
      Если Вы хотите вернуть товар после заказа/отменить заказ, Вам нужно:
      1. Оформить процедуру возврата товара или отмены заказа согласно процедуре сайта. Обычно на сайте или в электронном письме от магазина есть кнопка «отмена/возврат»; 
      2. ДО ПРИБЫТИЯ ПОСЫЛКИ НА СКЛАД в кнопке «Возврат (+)» 
      заполнить ТРЕК (НЕ номер заказа), 
      заполнить данные и 
      В поле комментарий написать «ВОЗВРАТ!!!!»; 
      3. Связаться с нами по Whatsapp и уточнить забрали ли коробку. 
      Возврат денежных средств осуществляет магазин на Вашу банковскую карту, посредством которой был произведен платеж за заказ. Сроки возврата денег разные у каждого сайта от 3 дней до 1 месяца.`,
  },
  {
    question: "14. После заказа курьерская компания отправила мне письмо и предложила посылку оставить на другом пункте выдачи?",
    answer: `Это стандартная практика у курьерских компаний вместо доставки посылки до адреса предложить оставить Вашу посылку в ближайшем пункте выдаче или на почте. Убедительно просим игнорировать такие письма и ничего не отвечать. 
      Если Вы сомневаетесь в тексте полученного письма, то лучше отправить нам скрин письма на Whatsapp и попросить помочь.`,
  },
  {
    question: "15. На что обратить внимание при заполнении адреса на сайте, где я покупаю товар?",
    answer: `Ваш заполненный адрес должен полностью на 100% соответствовать адресу в кнопке «Адреса зарубежных складов». Верно должны быть заполнены все параметры, включая индекс, город, клиентский код. 
      Склад США индекс может быть и 19701 и 19701-1324, оба индекса верные. 
      В Испании ни в коем случае нельзя пропускать в адресной строке «BMG», а в США «Onza». Это дома, где есть и другие компании, без этих индикаторов Ваша посылка может потеряться.
      Часто сайты на автомате рекомендуют ввести другой адрес.  Никогда не выбирайте адрес, который отличается от Вашего адреса, even если он окрашен зеленым цветом, а то, что Вы ввели окрашено розовым цветом. Ваш адрес с кнопки Адреса зарубежных складов является единственно верным.`,
  },
  {
    question: "16. Zara, Bershka и Stradivarius Испания при регистрации на сайте или в их приложении требует СМС код, где его взять?",
    answer: "Напишите нам на whatsapp, мы предоставим.",
  },
  {
    question: "17. Какой регион выбрать для Испании на сайтах?",
    answer: "Espana – просто, БЕЗ Канарских островов. Регионы могут быть Peninsula y Baleares, Andalucia или Malaga, в зависимости, что есть в выпадающем списке.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Вопросы и ответы</h1>
      {faqItems.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={index} style={styles.item}>
            <div
              style={styles.question}
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <span>{item.question}</span>
              <span style={styles.icon}>{isOpen ? "−" : "+"}</span>
            </div>

            {isOpen && (
              <div style={styles.answer}>
                {item.answer
                  .trim()
                  .split("\n")
                  .map((line, i) => (
                    <p key={i} style={styles.answerText}>
                      {line}
                    </p>
                  ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "20px 0",
    overflow: "auto",
    width: "calc(100% - 16px)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    margin: "0 0 14px 0",
    color: "#103d64",
  },
  item: {
    border: "1px solid #103d64",
    borderRadius: "12px",
    marginBottom: "14px",
    overflow: "hidden",
    background: "#fff",
  },
  question: {
    padding: "16px 20px",
    cursor: "pointer",
    fontWeight: "600",
    background: "#f3f8fc",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#103d64",
  },
  icon: {
    fontSize: "22px",
    lineHeight: "22px",
  },
  answer: {
    padding: "16px 20px",
    background: "#ffffff",
    lineHeight: "1.55",
    color: "#103d64",
  },
  answerText: {
    margin: "0 0 6px 0",
    fontSize: "14px",
  },
};